// Module
var code = "<div class=\"GamePlanSendingMomentHeader__root\"> <span>Generate Game Plan</span> <div class=\"GamePlanSendingMomentHeader__breadCrumbs\"> <nav-bread-crumb links=\"vm.items\"></nav-bread-crumb> </div> </div> ";
// Exports
module.exports = code;